import moment from "moment";
import { TooltipProps } from "recharts";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
const  toolTipTitleStyles : React.CSSProperties =  {
    paddingBottom: 10, 
    fontWeight: "bold", 
    textAlign : "center",
};
const toolTipOutline: React.CSSProperties =  {
    background: "#ffff", 
    borderRadius : 3, 
    opacity:0.86, 
    paddingLeft: 25, 
    paddingRight: 25, 
    paddingTop : 15,
    paddingBottom : 15, 
    marginTop: 0, 
    border:1 , 
    borderColor:"#c4c4c4",
    borderStyle : "solid"
}

const tooltipStyles  = {
    main : toolTipOutline,
    title: toolTipTitleStyles,
}


const Tooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
    if (active && payload && payload.length) {
      return (
        <div style={tooltipStyles.main}>
            <div style={tooltipStyles.title}>{moment(label).format("LLL")}</div>
            {payload.map( p => <div><span style={{color: p.color}}>{p.name}</span> : {p.value} floor</div>)}
        </div>
      );
    }
  
    return null;
};

export default Tooltip;